import React, { useMemo } from 'react'
import { useDashIntl } from 'intl/intl.hooks'
import { type DashMessages } from 'intl/intl.types'
import { DashLabel, type DashLabelProps } from 'legacy/dash-blocks/dash-label/DashLabel'

export interface LabelProps extends Omit<DashLabelProps, 'label'> {
  intlId: DashMessages
}

export const Label = ({ intlId, ...rest }: LabelProps) => {
  const intl = useDashIntl()
  const label = useMemo(() => intl.formatMessage({ id: intlId }), [intl, intlId])

  return <DashLabel {...rest} label={label} />
}
